import { Step, Field, FormDataType, StepCondition, FieldCondition } from '../types/form.types';

// Configuration simple des étapes (sera remplacée par le schéma complet)
export const FORM_STEPS = [
  {
    id: 'welcome',
    title: 'Bienvenue',
    description: 'Bonjour et bienvenue chez Yelloan',
    fields: [],
    nextStepId: 'simulation'
  },
  {
    id: 'simulation',
    title: 'Simulation',
    description: 'Combien souhaitez-vous emprunter ?',
    fields: [
      {
        id: 'amount',
        name: 'amount',
        type: 'number' as const,
        label: 'Montant souhaité (€)',
        placeholder: 'Ex: 15000',
        validation: {
          required: true,
          min: 500,
          max: 35000,
          errorMessage: 'Le montant doit être entre 500€ et 35 000€'
        }
      },
      {
        id: 'project_type',
        name: 'project_type',
        type: 'choice' as const,
        label: 'Quel est votre projet ?',
        options: [
          { value: 'travaux', label: 'Travaux maison' },
          { value: 'besoin', label: "Besoin d'argent" },
          { value: 'auto', label: 'Auto / moto' },
          { value: 'conso', label: 'Consommation' }
        ],
        validation: {
          required: true,
          errorMessage: 'Veuillez sélectionner un type de projet'
        }
      }
    ],
    nextStepId: 'duration'
  },
  {
    id: 'duration',
    title: 'Durée du crédit',
    description: 'Durée souhaitée du remboursement ?',
    fields: [
      {
        id: 'duration',
        name: 'duration',
        type: 'choice' as const,
        label: 'Durée',
        options: [
          { value: '6', label: '6 mois' },
          { value: '12', label: '12 mois' },
          { value: '18', label: '18 mois' },
          { value: '24', label: '24 mois' },
          { value: '36', label: '36 mois' },
          { value: '48', label: '48 mois' },
          { value: '60', label: '60 mois' },
          { value: '72', label: '72 mois' },
          { value: '84', label: '84 mois' }
        ],
        validation: {
          required: true,
          errorMessage: 'Veuillez sélectionner une durée'
        }
      }
    ],
    nextStepId: 'personal_info'
  },
  {
    id: 'personal_info',
    title: 'Informations personnelles',
    description: 'Passons aux informations de l\'emprunteur',
    fields: [
      {
        id: 'title',
        name: 'title',
        type: 'choice' as const,
        label: 'Titre',
        options: [
          { value: 'M', label: 'Monsieur' },
          { value: 'MME', label: 'Madame' },
          { value: 'MLE', label: 'Mademoiselle' }
        ],
        validation: {
          required: true,
          errorMessage: 'Veuillez sélectionner un titre'
        }
      },
      {
        id: 'firstName',
        name: 'firstName',
        type: 'text' as const,
        label: 'Prénom',
        placeholder: 'Votre prénom',
        validation: {
          required: true,
          minLength: 2,
          pattern: '^[a-zA-ZÀ-ÿ\\s-]+$',
          errorMessage: 'Le prénom doit contenir au moins 2 caractères'
        }
      },
      {
        id: 'lastName',
        name: 'lastName',
        type: 'text' as const,
        label: 'Nom de famille',
        placeholder: 'Votre nom',
        validation: {
          required: true,
          minLength: 2,
          pattern: '^[a-zA-ZÀ-ÿ\\s-]+$',
          errorMessage: 'Le nom doit contenir au moins 2 caractères'
        }
      },
      {
        id: 'email',
        name: 'email',
        type: 'email' as const,
        label: 'Email',
        placeholder: 'votre@email.com',
        validation: {
          required: true,
          errorMessage: 'Veuillez saisir un email valide'
        }
      },
      {
        id: 'birthDate',
        name: 'birthDate',
        type: 'date' as const,
        label: 'Date de naissance',
        validation: {
          required: true,
          errorMessage: 'Veuillez saisir votre date de naissance'
        }
      }
    ],
    nextStepId: 'co_borrower'
  },
  {
    id: 'co_borrower',
    title: 'Co-emprunteur',
    description: 'Informations sur le co-emprunteur',
    fields: [],
    condition: {
      field: 'hasCoBorrower',
      operator: 'equals' as const,
      values: ['true']
    },
    nextStepId: 'personal_situation'
  },
  {
    id: 'personal_situation',
    title: 'Situation personnelle',
    description: 'Informations sur votre situation familiale, logement et banque',
    fields: [],
    nextStepId: 'address'
  },
  {
    id: 'address',
    title: 'Adresse',
    description: 'Passons maintenant à votre adresse',
    fields: [
      {
        id: 'country',
        name: 'country',
        type: 'choice' as const,
        label: 'Dans quel pays habitez-vous ?',
        options: [
          { value: 'FR', label: 'France' },
          { value: 'MC', label: 'Monaco' }
        ],
        validation: {
          required: true,
          errorMessage: 'Veuillez sélectionner un pays'
        }
      },
      {
        id: 'city',
        name: 'city',
        type: 'text' as const,
        label: 'Ville',
        placeholder: 'Votre ville',
        validation: {
          required: true,
          minLength: 2,
          errorMessage: 'Veuillez saisir votre ville'
        }
      },
      {
        id: 'street',
        name: 'street',
        type: 'text' as const,
        label: 'N°, type et nom de la voie',
        placeholder: 'Ex: 123 rue de la Paix',
        validation: {
          required: true,
          minLength: 5,
          errorMessage: 'Veuillez saisir votre adresse complète'
        }
      },
      {
        id: 'postalCode',
        name: 'postalCode',
        type: 'text' as const,
        label: 'Code postal',
        placeholder: 'Ex: 75001',
        validation: {
          required: true,
          pattern: '^[0-9]{5}$',
          errorMessage: 'Le code postal doit contenir 5 chiffres'
        }
      }
    ],
    nextStepId: 'insurance'
  },
  {
    id: 'insurance',
    title: 'Assurance emprunteur',
    description: 'Souhaitez-vous souscrire à une assurance ?',
    fields: [],
    nextStepId: 'summary'
  },
  {
    id: 'summary',
    title: 'Récapitulatif',
    description: 'Vérifiez vos informations avant de soumettre votre demande',
    fields: [],
    nextStepId: 'success'
  },
  {
    id: 'success',
    title: 'Confirmation',
    description: 'Votre demande a bien été envoyée',
    fields: [],
    nextStepId: null
  }
];

// Évaluer une condition
export function evaluateCondition(condition: StepCondition | FieldCondition, formData: FormDataType): boolean {
  const fieldValue = formData[condition.field];
  
  const fieldValueStr = String(fieldValue);

  switch (condition.operator) {
    case 'equals':
      return fieldValueStr === condition.values[0];

    case 'not_equals':
      return fieldValueStr !== condition.values[0];

    case 'in':
      return condition.values.includes(fieldValueStr);

    case 'not_in':
      return !condition.values.includes(fieldValueStr);
    
    default:
      return true;
  }
}

// Déterminer si une étape doit être affichée
export function shouldShowStep(step: Step, formData: FormDataType): boolean {
  if (!step.condition) return true;
  return evaluateCondition(step.condition, formData);
}

// Obtenir la prochaine étape
export function getNextStepId(currentStepId: string, formData: FormDataType): string | null {
  const currentStep = FORM_STEPS.find(step => step.id === currentStepId);
  if (!currentStep) return null;

  let nextStepId = currentStep.nextStepId;

  // Vérifier si la prochaine étape a une condition
  while (nextStepId) {
    const nextStep = FORM_STEPS.find(step => step.id === nextStepId);
    if (!nextStep) return null;

    // Si l'étape n'a pas de condition ou si la condition est remplie, on la retourne
    if (shouldShowStep(nextStep, formData)) {
      return nextStepId;
    }

    // Sinon, on passe à l'étape suivante
    nextStepId = nextStep.nextStepId;
  }

  return null;
}

// Obtenir l'étape précédente
export function getPreviousStepId(_currentStepId: string, stepHistory: string[]): string | null {
  if (stepHistory.length === 0) return null;
  return stepHistory[stepHistory.length - 1];
}

// Obtenir une étape par son ID
export function getStepById(stepId: string): Step | undefined {
  return FORM_STEPS.find(step => step.id === stepId);
}

// Obtenir toutes les étapes visibles selon les données du formulaire
export function getVisibleSteps(formData: FormDataType): Step[] {
  return FORM_STEPS.filter(step => shouldShowStep(step, formData));
}

// Calculer la progression
export function calculateProgress(currentStepId: string, _completedSteps: string[], formData: FormDataType): {
  currentStepIndex: number;
  totalSteps: number;
  progressPercentage: number;
} {
  // Exclure 'success' du comptage (pas affiché dans la barre de progression)
  const visibleSteps = getVisibleSteps(formData).filter(step => step.id !== 'success');
  const currentStepIndex = visibleSteps.findIndex(step => step.id === currentStepId);
  const totalSteps = visibleSteps.length;
  
  const progressPercentage = Math.round(((currentStepIndex + 1) / totalSteps) * 100);
  
  return {
    currentStepIndex: currentStepIndex + 1,
    totalSteps,
    progressPercentage
  };
}

// Valider qu'une étape peut être complétée
export function canCompleteStep(step: Step, formData: FormDataType): boolean {
  return step.fields.every(field => {
    // Vérifier si le champ a des conditions d'affichage
    if (field.condition && !evaluateCondition(field.condition, formData)) {
      return true; // Le champ n'est pas affiché, donc il est "valide"
    }
    
    // Vérifier la validation requise
    if (field.validation?.required) {
      const value = formData[field.name];
      return value !== undefined && value !== '' && value !== null;
    }
    
    return true;
  });
}

// Obtenir les champs visibles d'une étape
export function getVisibleFields(step: Step, formData: FormDataType): Field[] {
  return step.fields.filter(field => {
    if (!field.condition) return true;
    return evaluateCondition(field.condition, formData);
  });
}